import Service from '@/services/abstract/service'
import FirebaseStorage from '@/services/firebase/storage'

export default class LayoutPdf extends Service {

  constructor() {
    super()

    this._layoutCollection = this._db.collection(`${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/LayoutArquivo`)
  }

  async create(data, arquivo) {
    try{
      let pdfUploaded = await new FirebaseStorage().uploadPdf(arquivo)

      data.fileName = pdfUploaded.fileName
      data.url = pdfUploaded.url
      data.ativo = true
      data.dataCriacao = new Date()
      data.tipo = 'pdf'

      await this._layoutCollection.doc().set(data)
      return Promise.resolve('Layout salvo com sucesso.')
    }catch(error){
      console.error(error)
      return Promise.reject(error)
    }

  }

  async createImagesForPDF(data, image, count) {
    try{
      let urls = []
      for(var i = 0; i < count; i++){
        let pdfUploaded = await new FirebaseStorage().uploadImagePdf(image[i])
        urls.push(pdfUploaded.url)
      }

      data.fileName = `image-${new Date().getTime()}`
      data.url = urls
      data.ativo = true
      data.dataCriacao = new Date()
      data.tipo = 'pdf'

      await this._layoutCollection.doc().set(data)
      return Promise.resolve('Layout salvo com sucesso.')
    }catch(error){
      console.error(error)
      return Promise.reject(error)
    }

  }

  async update(id, data)
  {
    try
    {
      data.dataAlteracao = new Date()

      await this._layoutCollection.doc(id).update(data)
      return Promise.resolve('Layout alterado com sucesso')
    }
    catch(error)
    {
      console.error(error)
      return Promise.reject(error)
    }
  }

  async getByCampanha(campanha) {
    let layouts = new Array()

    try{
      let layoutQuerySnap = await this._layoutCollection
          .where('tipo', '==', 'pdf')
          .where('campanha', '==', campanha)
          .where('ativo', '==', true)
          .get()
      if(!layoutQuerySnap.empty) {
        for(let layout of layoutQuerySnap.docs) {
          layouts.push({
            id: layout.id,
            ...layout.data()
          })
        }
      }

      return Promise.resolve(layouts)
    }catch(error){
      console.error(error)
      return Promise.reject(error)
    }
  }

}
